import { ReactNode } from 'react';

type SettingsPanelProps = {
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
};

type SettingsRowProps = {
  label: ReactNode;
  value: ReactNode;
  title?: string;
  action: ReactNode;
};

export const SettingsPanel = ({ title, description, children }: SettingsPanelProps) => (
  <section className='mt-5 overflow-hidden rounded-2xl border border-ob-border bg-ob-raised first-of-type:mt-8'>
    <div className='border-b border-ob-border-soft px-6 py-[22px]'>
      <h2 className='text-lg font-medium text-ob-text'>{title}</h2>
      <p className='mt-1.5 text-sm text-ob-text-subtle'>{description}</p>
    </div>
    {children}
  </section>
);

export const SettingsRow = ({ label, value, title, action }: SettingsRowProps) => (
  <div className='flex min-h-[76px] flex-col items-start justify-between gap-3 px-6 py-4 sm:flex-row sm:items-center sm:gap-6'>
    <div className='grid min-w-0 max-w-full gap-1.5'>
      <span className='text-[13px] text-ob-text-subtle'>{label}</span>
      <strong className='truncate font-medium text-ob-text-secondary' title={title}>{value}</strong>
    </div>
    {action}
  </div>
);
